import React from "react";

const Chip = ({ classes, label }) => {
    return (
        <div className={`border-primary border-2 border-solid rounded-full px-2 py-1 text-xs ${classes}`}>
            {label}
        </div>
    );
}

export default Chip;